// Copyright 2025. WebPros International GmbH. All rights reserved.

import {
    Heading,
    Translate,
} from '@plesk/ui-library';
import { IComputeResourceRecoveryReadinessStatusResponse } from 'common/api/resources/DisasterRecovery';
import AvailableResourcesItem from 'admin/disasterRecovery/components/AvailableResourceItem/AvailableResourcesItem';

export default function AvailableResources({
    availableResources,
    requireResources,
}: {
    availableResources?: IComputeResourceRecoveryReadinessStatusResponse['available_resources'];
    requireResources?: IComputeResourceRecoveryReadinessStatusResponse['require_resources'];
}) {
    return (
        <div style={{ marginBottom: 16 }}>
            <Heading level={3}>
                <Translate content="disasterRecovery.readinessStatus.availableResource.title" />
            </Heading>

            <AvailableResourcesItem
                title={<Translate content="disasterRecovery.readinessStatus.availableResource.vmWithDr" />}
                requireResources={requireResources?.for_vms_disaster_recovery_enabled}
                availableResources={availableResources}
            />

            <AvailableResourcesItem
                title={<Translate content="disasterRecovery.readinessStatus.availableResource.vmWithBackups" />}
                requireResources={requireResources?.for_vms_with_backups}
                availableResources={availableResources}
            />

            <AvailableResourcesItem
                title={<Translate content="disasterRecovery.readinessStatus.availableResource.all" />}
                requireResources={requireResources?.for_all_vms}
                availableResources={availableResources}
            />
        </div>
    );
}
